<template>
  <el-table-column
    prop="cm_delivery_note_number"
    label="CM szlev szám"
    width="150"
    sortable="custom"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.cm_delivery_note_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'cm_delivery_note_number',
  };
</script>
